/**
 * 场地
 * @description 场地新增、编辑
 * @author mll
 * @date 2020-1-22
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd'
import { component_tool, framework_tool } from '@/tool'
import $$ from 'cmn-utils';
import { formatAuth } from '@/utils/commonUtils'

let { WizAvatarUpload, ossFileUtils } = framework_tool
let {
    WizButton,
    WizSelect,
    WizTooltip,
    WizInput,
    WizIcon,
    WizSwitch,
    WizLocationSelect,
    WizRow,
    WizCol,
    WizRadio,
    WizDivider,
    WizCheckbox,
    WizInputNumber
} = component_tool;
let WizForm = Form
let Item = Form.Item
let Option = WizSelect.Option
import { WizTableForm, WizAuthority } from '../../../common'

/**
 * 此组件没有继承WizComponent，因为需要使用Form.create()该组件
 * 继承WizComponent后 form的部分功能缺失了
 * 初步怀疑是WizComponent修改了生命周期的钩子导致的
 * by mll 2020-2-4
 */

class SiteFrom extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        let { data, form } = this.props;
        let _state = Object.assign({}, this.state);
        _state['type'] = data ? data['type'] : undefined;
        _state['allowOrder'] = data['allowOrder'] === 0 ? true : false;
        let authInfo = data['authInfo']
        let targetScope = {}
        if (authInfo) {
            if (authInfo['orgIds']) {
                targetScope['orgIds'] = authInfo['orgIds']
            }
            if (authInfo['positionCategoryIds']) {
                targetScope['positionCategoryIds'] = authInfo['positionCategoryIds']
            }
        }
        _state['targetScope'] = targetScope;
        this.setState(_state)
    }

    /**
     * 数据校验方法
     */
    targetScopeValidator = (rule, value, callback) => {
        if (!value) {
            callback('请选择适用范围');
            return;
        }
        if (!value['groupId'] || (value['groupId'] && !value['groupId'].length)) {
            if (!value['orgIds'] || (value['orgIds'] && !value['orgIds'].length)) {
                callback('请选择品牌');
                return;
            }
            if (!value['positionCategoryIds'] || (value['positionCategoryIds'] && !value['positionCategoryIds'].length)) {
                callback('请选择岗位分类');
                return;
            }
        }
        callback();
    }

    trainCenterIdValidator = (rule, value, callback) => {
        if (!value) {
            callback('请选择培训中心');
        }
        callback();
    }

    /**
     * 表单基础内容
     */
    _base() {
        let { getFieldDecorator } = this.props.form;
        let { data } = this.props;
        let { allowOrder } = this.state;
        return [
            <Item label="场地类型" >
                {getFieldDecorator('type', {
                    initialValue: data.type,
                    rules: [{ required: true, message: '请选择场地类型' }],
                })(
                    <WizSelect
                        placeholder="请选择场地类型"
                        onChange={(type) => { this.setState({ type }) }}
                    >
                        <Option value={0}>教室</Option>
                        <Option value={1}>大门</Option>
                        <Option value={2}>餐厅</Option>
                        <Option value={3}>其他</Option>
                    </WizSelect>,
                )}
            </Item>,
            <Item label="场地名称" >
                {getFieldDecorator('name', {
                    initialValue: data.name,
                    rules: [{ required: true, message: '请输入场地名称', whitespace: true }],
                })(<WizInput maxLength={30} placeholder='请输入场地名称,最多30字' />)}
            </Item>,
            <Item label="场地编号" >
                {getFieldDecorator('code', {
                    initialValue: data.code,
                    rules: [{ required: true, message: '请输入场地编号', whitespace: true }],
                })(<WizInput maxLength={50} placeholder='请输入场地编号' />)}
            </Item>,
            <Item label="培训中心" >
                {getFieldDecorator('trainCenterId', {
                    initialValue: data.trainCenterId,
                    rules: [{ required: true, validator: this.trainCenterIdValidator }],
                })(
                    <WizTableForm
                        key={'trainCenter'}
                        {...WizTableForm.Config.trainCenter()}
                        selectType={'radio'}
                        initRows={data.trainCenterId ? [{ id: data.trainCenterId, name: data.trainCenterName }] : []}
                        onClearWiz={(trainCenterReset) => { this.trainCenterReset = trainCenterReset }}
                    />
                )}
            </Item>,
            <Item label="城市" >
                {getFieldDecorator('city', {
                    initialValue: data.city,
                    rules: [{ required: true, message: '请选择城市', whitespace: true }],
                })(<WizLocationSelect optionType='city' showSearch={true} />)}
            </Item>,
            <Item label="地址" >
              {getFieldDecorator('address', {
                initialValue: data.address,
                rules: [{ required: true, message: '请输入地址', whitespace: true }],
              })(<WizInput maxLength={100} placeholder='请输入地址' />)}
            </Item>,
            <Item label="预约设置">
                {getFieldDecorator('_allowOrder',
                    {
                        valuePropName: 'checked',
                        initialValue: data.allowOrder === 0 ? true : false
                    })(
                        <WizSwitch
                            style={{ marginRight: 10 }}
                            checkedChildren={<WizIcon type="check" />}
                            unCheckedChildren={<WizIcon type="close" />}
                            onChange={(allowOrder) => { this.setState({ allowOrder }) }}
                        />
                    )}
                <WizTooltip title="勾选后,表示该场地可以预约并选择审核类型。">
                    <WizIcon type="question-circle-o" />
                </WizTooltip>
            </Item>,
            allowOrder ? <Item label="审核类型">
                {getFieldDecorator('auditType', {
                    initialValue: data.auditType || 0
                })(
                    <WizRadio.Group>
                        <WizRadio value={0}>自动审核</WizRadio>
                        <WizRadio value={1}>手动审核</WizRadio>
                    </WizRadio.Group>,
                )}
            </Item> : null,
            allowOrder ? <Item label="场地管理员" >
                {getFieldDecorator('managerPersonId', {
                    initialValue: data.managerPersonId,
                    rules: [{ required: true, message: '请选择场地管理员', whitespace: true }],
                })(
                    <WizTableForm
                        key={'user'}
                        {...WizTableForm.Config.user()}
                        selectType={'radio'}
                        initRows={data.managerPersonId ? [{ id: data.managerPersonId, fullName: data.managerPersonName }] : []}
                    />
                )}
            </Item> : null,
            <Item label="场地状态">
                {getFieldDecorator('status', {
                    initialValue: data.status || 0
                })(
                    <WizRadio.Group>
                        <WizRadio value={0}>正常</WizRadio>
                        <WizRadio value={1}>停止使用</WizRadio>
                        <WizRadio value={2}>维修中</WizRadio>
                    </WizRadio.Group>,
                )}
            </Item>,
            <Item label="备注" >
                {getFieldDecorator('remark', {
                    initialValue: data.remark,
                })(<WizInput.TextArea maxLength={100} placeholder='请输入备注,最多100字' />)}
            </Item>,
        ]
    }

    handleReset = () => {
        //表单重置
        this.props.form && this.props.form.resetFields()
        //培训中心重置钩子
        this.trainCenterReset && this.trainCenterReset()
        //额外区域重置
        let { data } = this.props
        this.setState({ type: data ? data['type'] : undefined })
    }

    /**
     * 表单提交按钮
     */
    _submit() {
        return (
            <Item wrapperCol={{ span: 12, offset: 6 }}>
                <WizRow>
                    <WizCol span={24} style={{ textAlign: 'center' }}>
                        <WizButton type="primary" htmlType="submit">
                            保存
                        </WizButton>
                        <WizButton style={{ marginLeft: 20 }} onClick={this.handleReset}>
                            重置
                        </WizButton>
                    </WizCol>
                </WizRow>
            </Item>
        )
    }

    /**
     * 拓展属性
     */
    _ext = () => {
        if (this.state.type === 0) {
            return this._classroom()
        }
        return null;

    }

    /**
     * 教室属性
     */
    _classroom = () => {
        let { getFieldDecorator } = this.props.form;
        let { data } = this.props;
        let { targetScope } = this.state
        return [
            <Item wrapperCol={{ span: 18, offset: 3 }}>
                <WizDivider>
                    教室设置
                </WizDivider>
            </Item>,
            <Item label="教室用途" >
                {getFieldDecorator('purpose', {
                    initialValue: data.purpose || 0,
                    rules: [{ required: true, message: '请选择教室用途' }],
                })(
                    <WizSelect
                        placeholder="请选择教室用途"
                    >
                        <Option value={0}>不限制</Option>
                        <Option value={1}>新产品培训</Option>
                        <Option value={2}>实操培训</Option>
                        <Option value={3}>岗位培训</Option>
                        <Option value={4}>区域会议</Option>
                        <Option value={5}>岗位认证</Option>
                        <Option value={6}>其他</Option>
                    </WizSelect>,
                )}
            </Item>,
            <Item label="教室类型" >
                {getFieldDecorator('classroomType', {
                    initialValue: data.classroomType || 0,
                    rules: [{ required: true, message: '请选择教室类型' }],
                })(
                    <WizSelect
                        placeholder="请选择教室类型"
                    >
                        <Option value={0}>普通教室</Option>
                        <Option value={1}>进车</Option>
                        <Option value={2}>模拟展厅</Option>
                        <Option value={3}>技术银级认证教室</Option>
                        <Option value={4}>技术铜级认证教室</Option>
                        <Option value={5}>技术IBT教室</Option>
                        <Option value={6}>技术ILT实操教室</Option>
                        <Option value={7}>培训教室</Option>
                        <Option value={8}>电脑教室</Option>
                        <Option value={9}>多功能教室</Option>
                        <Option value={10}>二手车培训教室</Option>
                        <Option value={11}>技术培训教室</Option>
                        <Option value={12}>绕车演练场地</Option>
                        <Option value={13}>技术实操教室</Option>
                        <Option value={14}>多功能培训教室</Option>
                        <Option value={15}>多功能会议室</Option>
                    </WizSelect>,
                )}
            </Item>,
            <Item label="适用范围" >
                {getFieldDecorator('targetScope', {
                    initialValue: targetScope,
                    rules: [{ required: true, validator: this.targetScopeValidator }],
                })(
                    <WizAuthority
                        mode={'Form'}
                        // classname={'demo-authority'}
                        hasRadioGroup={false}
                        keys={['orgIds', 'positionCategoryIds']}
                        keyConfig={{
                            orgIds: {
                                title: '品牌选择',
                                config: WizTableForm.Config.organization(this, { apiParams: { state: 1, organizationNodeCategory: ["2"] } })
                            }
                        }}
                    />
                )}
            </Item>,
            <Item label="教室配置">
                {getFieldDecorator('fixedEquipments', {
                    initialValue: data.fixedEquipments ? data.fixedEquipments.split(',').map(i => parseInt(i)) : []
                })(
                    <WizCheckbox.Group>
                        <WizCheckbox value={0}>投影仪</WizCheckbox>
                        <WizCheckbox value={1}>培训器具</WizCheckbox>
                        <WizCheckbox value={2}>笔记本电脑</WizCheckbox>
                        <WizCheckbox value={3}>灯具</WizCheckbox>
                        <WizCheckbox value={4}>举升机</WizCheckbox>
                    </WizCheckbox.Group>,
                )}
            </Item>,
            <Item label="座位(数量)" >
                {getFieldDecorator('seat', {
                    initialValue: data.seat || 0,
                })(<WizInputNumber min={0} />)}
            </Item>,
            <Item label="进车(数量)" >
                {getFieldDecorator('parkingSpace', {
                    initialValue: data.parkingSpace || 0,
                })(<WizInputNumber min={0} />)}
            </Item>,
            <Item label="教室面积㎡" >
                {getFieldDecorator('floorSpace', {
                    initialValue: data.floorSpace || 0,
                })(<WizInputNumber min={0} />)}
            </Item>,
        ]
    }

    /**
    * 处理表单提交事件
    */
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                values['allowOrder'] = values['_allowOrder'] ? 0 : 1
                let { submit, data } = this.props
                let _values = Object.assign({}, values)
                //targetScope
                // let orgIds = [], positionCategoryIds = [];
                // if (_values['targetScope']) {
                //     if (_values['targetScope']['orgIds']) {
                //         orgIds = _values['targetScope']['orgIds'].map(i => i['id'])
                //     }
                //     if (_values['targetScope']['positionCategoryIds']) {
                //         positionCategoryIds = _values['targetScope']['positionCategoryIds'].map(i => i['id'])
                //     }
                // }

                _values.targetScope = formatAuth(_values.targetScope)

                //allowOrder
                let { allowOrder } = this.state;
                if (allowOrder === true) {
                    _values['allowOrder'] === 0
                } else {
                    _values['allowOrder'] === 1
                }
                _values['orgIds'] = _values.targetScope.orgIds;
                _values['positionCategoryIds'] = _values.targetScope.positionCategoryIds;
                //id
                if (!_values['id'] && data['id']) {
                    _values['id'] = data['id']
                }
                //classroomId
                if (!_values['classroomId'] && data['classroomId']) {
                    _values['classroomId'] = data['classroomId']
                }
                submit && submit(_values)
            }
        });
    };

    render() {
        log.info('this.props:', this.props)
        log.info('this.state:', this.state)
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
        };
        return (
            <WizForm
                {...formItemLayout}
                onSubmit={this.handleSubmit}
            >
                {this._base()}
                {this._ext()}
                {this._submit()}
            </WizForm>
        )

    }
}

export default WizForm.create()(SiteFrom);

/**
 * 默认值
 */
SiteFrom.defaultProps = {
    // title: '新增题目',
    data: {},
    selects: []
}

/**
 * props入参校验
 */
SiteFrom.propTypes = {
    // title: PropTypes.string.isRequired,//卡片标题
    // submit: PropTypes.fun,//提交的回调方法
    // data: PropTypes.object,//Info信息
    // treeSelectList: PropTypes.node,//分类树组件
    // treeData: PropTypes.array,//treeData
    // selects: PropTypes.array
}
